module.exports = __webpack_public_path__ + "static/img/airoad_combination02.69bae670.png";